import {orderSearchFormPage} from "@commons/userTracks/viewActionName";
import {recordUserViewTrack} from "@commons/userTracks/userTrack";

$(function () {
    recordUserViewTrack(orderSearchFormPage);
});
